import React from "react";

/**
 * Renders price like the reference:  ₹1,899  ~~₹2,999~~  [37% off]
 * Falls back to just ₹price if mrp is missing or <= price.
 */
export default function PriceTag({ price, mrp, size = "md", className = "" }) {
  const showDiscount = mrp && mrp > price;
  const pct = showDiscount ? Math.round(((mrp - price) / mrp) * 100) : 0;
  const fmt = (n) => `₹${Number(n).toLocaleString("en-IN", { maximumFractionDigits: 0 })}`;

  const sizes = {
    sm: { price: "text-sm", mrp: "text-[11px]", badge: "text-[10px] px-1.5 py-0.5" },
    md: { price: "text-base", mrp: "text-xs", badge: "text-[11px] px-2 py-0.5" },
    lg: { price: "text-2xl", mrp: "text-sm", badge: "text-xs px-2 py-1" },
    xl: { price: "text-3xl md:text-4xl", mrp: "text-base", badge: "text-sm px-2.5 py-1" },
  };
  const s = sizes[size] || sizes.md;

  return (
    <div className={`flex items-baseline gap-2 flex-wrap ${className}`}>
      <span className={`font-mono-cult font-bold text-[#CFF048] ${s.price}`} data-testid="price-current">{fmt(price)}</span>
      {showDiscount && (
        <>
          <span className={`font-mono-cult text-[#71717A] line-through ${s.mrp}`} data-testid="price-mrp">{fmt(mrp)}</span>
          <span className={`font-display font-bold bg-green-600 text-white ${s.badge}`} data-testid="price-discount">{pct}% off</span>
        </>
      )}
    </div>
  );
}
